import parser from './parser'

export default function permissions(context) {
  const { grants = {} } = context
  const roles = Object.keys(grants)

  const parse = parser(context)

  return roles.reduce(
    (acc, role) => ({
      ...acc,
      [role]: parse(role).reduce(
        (r, c) => ({
          ...r,
          [c]: true,
        }),
        {},
      ),
    }),
    {},
  )
}
